<app-page-header></app-page-header>

<div class="card-wrapper">
  <div class="card">
    <div class="card-body">
      <div id="clients-table-wrapper" class="k-w-full">
        <app-shive-grid #gridWrapperComponent [grid]="grid">
          <kendo-grid
            #grid
            kendoGridSelectBy="id"
            scrollable="none"
            size="medium"
            [kendoGridBinding]="timetableEntries()"
            [pageSize]="20"
            [selectable]="{ enabled: true, checkboxOnly: true }"
            [columnMenu]="{ filter: true }"
          >
            <ng-template kendoGridToolbarTemplate>
              <div class="k-d-flex k-align-items-center k-w-full k-justify-content-between">
                <h3 class="headline">Jahresübersicht</h3>
                <!-- Not really a form, but use k-form here to set the correct styling -->
                <div class="k-form">
                  <app-timetable-year-selection />
                </div>
              </div>
            </ng-template>

            <kendo-grid-checkbox-column
              [width]="60"
              [headerClass]="{ 'k-text-center': true }"
              [class]="{ 'k-text-center': true }"
              [resizable]="false"
              [columnMenu]="false"
              [showSelectAll]="true"
            ></kendo-grid-checkbox-column>

            <kendo-grid-column
              field="member_name"
              title="Projektmitglied"
              [class]="'cell-with-avatar'"
            >
              <ng-template kendoGridCellTemplate let-row>
                <div class="k-d-inline-flex k-align-items-center">
                  <app-shive-avatar [user]="row.user"></app-shive-avatar>
                  <div class="member-name k-ml-3">{{ row.user | memberName }}</div>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column title="Stundenkonto" class="!k-px-5">
              <ng-template kendoGridHeaderTemplate let-headerText>
                <div>
                  <span class="k-font-semibold">{{ headerText.title }}</span>

                  <span #popupAnchor>
                    <a shivePopup [popupAnchor]="popupAnchor" [content]="templateThree">
                      <fa-icon class="k-ml-2.5 turquoise" [icon]="faCircleInfo" size="lg"></fa-icon>
                    </a>
                  </span>
                </div>
              </ng-template>
              <ng-template kendoGridCellTemplate let-row>
                <app-fuelbar
                  [currentVal]="row.secondsWorked"
                  [maxVal]="row.secondsPlannedWorkingTime"
                >
                </app-fuelbar>
                <div class="k-d-flex">
                  <div class="current-value k-font-semibold turquoise">
                    {{ row.secondsWorked | timeFormat: TimeFormatType.SecondsToHoursAndMinutes }}
                  </div>
                  <div class="k-mx-1.5">von</div>
                  <div class="maximum-value k-mr-1.5 k-font-semibold">
                    {{
                      row.secondsPlannedWorkingTime
                        | timeFormat: TimeFormatType.SecondsToHoursAndMinutes
                    }}
                  </div>
                  Stunden geleistet.
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="VacationDays" title="Urlaubstage" class="!k-px-5">
              <ng-template kendoGridCellTemplate let-row>
                <app-fuelbar
                  [currentVal]="row.secondsConsumedVacation"
                  [maxVal]="row.secondsAnnualVacationQuota"
                >
                </app-fuelbar>
                <div class="k-d-flex">
                  <div class="current-value k-font-semibold turquoise">
                    {{
                      row.secondsConsumedVacation | timeFormat: TimeFormatType.SecondsToDaysDecimal
                    }}
                  </div>
                  <div class="k-mx-1.5">von</div>
                  <div class="maximum-value k-mr-1.5 k-font-semibold">
                    {{
                      row.secondsAnnualVacationQuota
                        | timeFormat: TimeFormatType.SecondsToDaysDecimal
                    }}
                  </div>
                  Tagen konsumiert.
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="UnitPrice" title="Krankheitstage">
              <ng-template kendoGridCellTemplate let-row>
                <div class="k-d-flex">
                  <div class="k-font-semibold">
                    {{ row.secondsSickLeave | timeFormat: TimeFormatType.SecondsToDaysDecimal }}
                  </div>

                  <span #popupAnchor>
                    <a shivePopup [popupAnchor]="popupAnchor" [content]="template">
                      <fa-icon class="k-ml-2.5 turquoise" [icon]="faCircleInfo" size="lg"></fa-icon>
                    </a>
                  </span>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="UnitPrice" title="Sonstige Abwesenheitstage">
              <ng-template kendoGridCellTemplate let-row>
                <div class="k-d-flex">
                  <div class="k-font-semibold">
                    {{ row.otherAbsenceTime | timeFormat: TimeFormatType.SecondsToDaysDecimal }}
                  </div>

                  <span #popupAnchor>
                    <a shivePopup [popupAnchor]="popupAnchor" [content]="templateTwo">
                      <fa-icon class="k-ml-2.5 turquoise" [icon]="faCircleInfo" size="lg"></fa-icon>
                    </a>
                  </span>
                </div>
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="contextMenu" title="" [columnMenu]="false" [width]="60">
              <ng-template kendoGridCellTemplate let-dataItem>
                <app-context-menu-anchor
                  [dataItem]="dataItem"
                  [gridWrapperComponent]="gridWrapperComponent"
                />
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </app-shive-grid>
      </div>
    </div>
  </div>
</div>

<ng-template #template>
  <div style="margin: 15px; z-index: 2">
    Entspricht <span class="k-font-semibold">4 Tage mehr</span> als 2023.
  </div>
</ng-template>

<ng-template #templateTwo>
  <div style="margin: 15px; z-index: 2">
    <div class="mb-2 k-font-weight-semibold">Abwesenheitsgründe</div>
    <ul class="k-m-0">
      <li>Umzug (2 Tage)</li>
      <li>Hochzeit (1 Tag)</li>
    </ul>
  </div>
</ng-template>

<ng-template #templateThree>
  <div style="margin: 15px; z-index: 2; max-width: 180px; text-wrap: balance">
    Geleistete Stunden sind Projektstunden plus vergütete Abwesenheitsstunden (zum Beispiel Urlaub,
    Krankenstand, etc.)
  </div>
</ng-template>
